// import i18next from "i18next"
export const ScreenCode = {
  HOME: "HOME",
  MY_TASKS: "MY_TASKS",
  CREATE_TASK: "CREATE_TASK",
  SEARCH_TASK: "SEARCH_EDIT_TASKS",
  TASK_DETAIL: "TASK_DETAIL",
  MY_PROFILE: "MY_PROFILE",
  CREATE_COMMUNICATION: "CREATE_COMMUNICATION",
  MY_COMMUNICATIONS: "MY_COMMUNICATIONS",
  COMMUNICATION_DETAIL: "COMMUNICATION_DETAIL",
  COMMUNICATION_VIEW: "COMMUNICATION_VIEW",
  // DASHBOARD_V2: "DASHBOARD_V2",
  DASHBOARD_V3: "DASHBOARD_V3",
  SEARCH_COMMUNICATION: "SEARCH_EDIT_COMMUNICATIONS",
  NOTIFICATIONS: "NOTIFICATIONS",
  DASHBOARD: "DASHBOARD",
}
export const APIController = {
  [ScreenCode.DASHBOARD]: "DashboardV3",
  [ScreenCode.TASK_DETAIL]: "Task",
  [ScreenCode.COMMUNICATION_VIEW]: "MyCommunicationDetail",
  [ScreenCode.COMMUNICATION_DETAIL]: "MyCommunicationDetail",
  [ScreenCode.MY_TASKS]: "WebUserScreenV2", //"MyTasks_Web",
  [ScreenCode.SEARCH_TASK]: "WebUserScreenV2", //"SearchTask",
  [ScreenCode.MY_COMMUNICATIONS]: "WebUserScreenV2", //"MyCommunications",
  [ScreenCode.SEARCH_COMMUNICATION]: "WebUserScreenV2", //"SearchCommunication",
}
export const Path = {
  [ScreenCode.HOME]: "/",
  [ScreenCode.DASHBOARD]: "/dashboard",
  [ScreenCode.MY_TASKS]: "/my-tasks",
  [ScreenCode.CREATE_TASK]: "/create-task",
  [ScreenCode.SEARCH_TASK]: "/search-task",
  [ScreenCode.MY_PROFILE]: "/my-profile",
  [ScreenCode.CREATE_COMMUNICATION]: "/create-communication",
  [ScreenCode.MY_COMMUNICATIONS]: "/my-communications",
  // [ScreenCode.DASHBOARD_V2]: "/dashboardv2",
  [ScreenCode.DASHBOARD_V3]: "/dashboardv3",
  [ScreenCode.SEARCH_COMMUNICATION]: "/search-communication",
  [ScreenCode.NOTIFICATIONS]: "/notifications",
  [ScreenCode.TASK_DETAIL]: "/task/:TaskFromURL",
  [ScreenCode.COMMUNICATION_DETAIL]: "/communication/:ID_GUID",
  [ScreenCode.COMMUNICATION_VIEW]: "/communication/view/:ID_GUID",
}
export const TitlePage = {
  [ScreenCode.HOME]: "dnt:sidebarmenu.Home",
  [ScreenCode.DASHBOARD]: "dnt:sidebarmenu.Dashboard",
  [ScreenCode.MY_TASKS]: "dnt:sidebarmenu.My Tasks",
  [ScreenCode.CREATE_TASK]: "dnt:sidebarmenu.Create Task",
  [ScreenCode.SEARCH_TASK]: "dnt:sidebarmenu.Search",
  [ScreenCode.MY_PROFILE]: "headermenu.Profile",
  [ScreenCode.CREATE_COMMUNICATION]: "dnt:sidebarmenu.Create Communication",
  [ScreenCode.MY_COMMUNICATIONS]: "dnt:sidebarmenu.My Communications",
  // [ScreenCode.DASHBOARD_V2]: "dnt:sidebarmenu.Dashboard v2",
  [ScreenCode.DASHBOARD_V3]: "dnt:sidebarmenu.Dashboard v3",
  [ScreenCode.SEARCH_COMMUNICATION]: "dnt:sidebarmenu.Search Communication",
  [ScreenCode.NOTIFICATIONS]: "dnt:notification.Title",
}
export const PageType = {
  [ScreenCode.HOME]: "home",
  [ScreenCode.DASHBOARD]: "dashboardv3",
  [ScreenCode.MY_TASKS]: "general", //"my_tasks",
  [ScreenCode.CREATE_TASK]: "create_task",
  [ScreenCode.SEARCH_TASK]: "general", //"search_edit_tasks",
  [ScreenCode.TASK_DETAIL]: "task_detail",
  [ScreenCode.MY_PROFILE]: "my_profile",
  [ScreenCode.CREATE_COMMUNICATION]: "create_communication",
  [ScreenCode.MY_COMMUNICATIONS]: "general", //"my_communications",
  [ScreenCode.SEARCH_COMMUNICATION]: "general", //"search_edit_communications",
  [ScreenCode.COMMUNICATION_DETAIL]: "communication_detail",
  [ScreenCode.COMMUNICATION_VIEW]: "communication_view",
  [ScreenCode.NOTIFICATIONS]: "notifications",
}
export const DashboardConfig = {
  Id: "DASHBOARD",
  ScreenCode: "DASHBOARD",
  Title: TitlePage[ScreenCode.DASHBOARD],
  UIUrl: Path[ScreenCode.DASHBOARD],
  APIName: APIController[ScreenCode.DASHBOARD],
  UIType: "dashboardv3",
}
export const ConfigPageScreen = {
  [ScreenCode.DASHBOARD]: DashboardConfig,
  [ScreenCode.MY_TASKS]: {
    ScreenCode: ScreenCode.MY_TASKS,
    Id: ScreenCode.MY_TASKS,
    Title: TitlePage[ScreenCode.MY_TASKS],
    APIName: APIController[ScreenCode.MY_TASKS], //"MyTasks_Web",
    UIUrl: Path[ScreenCode.MY_TASKS],
    UIType: PageType[ScreenCode.MY_TASKS],
  },
  [ScreenCode.CREATE_TASK]: {
    Id: ScreenCode.CREATE_TASK,
    Title: TitlePage[ScreenCode.CREATE_TASK],
    UIUrl: Path[ScreenCode.CREATE_TASK],
    UIType: PageType[ScreenCode.CREATE_TASK],
    ScreenCode: ScreenCode.CREATE_TASK,
  },
  [ScreenCode.SEARCH_TASK]: {
    Id: ScreenCode.SEARCH_TASK,
    Title: TitlePage[ScreenCode.SEARCH_TASK],
    UIUrl: Path[ScreenCode.SEARCH_TASK],
    APIName: APIController[ScreenCode.SEARCH_TASK],
    UIType: PageType[ScreenCode.SEARCH_TASK],
    ScreenCode: ScreenCode.SEARCH_TASK,
  },
  [ScreenCode.MY_PROFILE]: {
    Id: ScreenCode.MY_PROFILE,
    Title: TitlePage[ScreenCode.MY_PROFILE],
    UIUrl: Path[ScreenCode.MY_PROFILE],
    UIType: PageType[ScreenCode.MY_PROFILE],
    ScreenCode: ScreenCode.MY_PROFILE,
  },
  [ScreenCode.CREATE_COMMUNICATION]: {
    Id: ScreenCode.CREATE_COMMUNICATION,
    Title: TitlePage[ScreenCode.CREATE_COMMUNICATION],
    UIUrl: Path[ScreenCode.CREATE_COMMUNICATION],
    UIType: PageType[ScreenCode.CREATE_COMMUNICATION],
    ScreenCode: ScreenCode.CREATE_COMMUNICATION,
  },
  [ScreenCode.MY_COMMUNICATIONS]: {
    Id: ScreenCode.MY_COMMUNICATIONS,
    Title: TitlePage[ScreenCode.MY_COMMUNICATIONS],
    APIName: APIController[ScreenCode.MY_COMMUNICATIONS],
    UIUrl: Path[ScreenCode.MY_COMMUNICATIONS],
    UIType: PageType[ScreenCode.MY_COMMUNICATIONS],
    ScreenCode: ScreenCode.MY_COMMUNICATIONS,
  },
  [ScreenCode.SEARCH_COMMUNICATION]: {
    Id: ScreenCode.SEARCH_COMMUNICATION,
    Title: TitlePage[ScreenCode.SEARCH_COMMUNICATION],
    APIName: APIController[ScreenCode.SEARCH_COMMUNICATION],
    UIUrl: Path[ScreenCode.SEARCH_COMMUNICATION],
    UIType: PageType[ScreenCode.SEARCH_COMMUNICATION],
    ScreenCode: ScreenCode.SEARCH_COMMUNICATION,
  },
  [ScreenCode.NOTIFICATIONS]: {
    Id: ScreenCode.NOTIFICATIONS,
    Title: TitlePage[ScreenCode.NOTIFICATIONS],
    UIUrl: Path[ScreenCode.NOTIFICATIONS],
    UIType: PageType[ScreenCode.NOTIFICATIONS],
    ScreenCode: ScreenCode.NOTIFICATIONS,
  },
  [ScreenCode.TASK_DETAIL]: {
    Id: ScreenCode.TASK_DETAIL,
    APIName: APIController[ScreenCode.TASK_DETAIL],
    UIUrl: Path[ScreenCode.TASK_DETAIL],
    UIType: PageType[ScreenCode.TASK_DETAIL],
    ScreenCode: ScreenCode.TASK_DETAIL,
  },
  [ScreenCode.COMMUNICATION_DETAIL]: {
    Id: ScreenCode.COMMUNICATION_DETAIL,
    APIName: APIController[ScreenCode.COMMUNICATION_DETAIL],
    UIUrl: Path[ScreenCode.COMMUNICATION_DETAIL],
    UIType: PageType[ScreenCode.COMMUNICATION_DETAIL],
    ScreenCode: ScreenCode.COMMUNICATION_DETAIL,
  },
  [ScreenCode.COMMUNICATION_VIEW]: {
    Id: ScreenCode.COMMUNICATION_VIEW,
    APIName: APIController[ScreenCode.COMMUNICATION_VIEW],
    UIUrl: Path[ScreenCode.COMMUNICATION_VIEW],
    UIType: PageType[ScreenCode.COMMUNICATION_VIEW],
    ScreenCode: ScreenCode.COMMUNICATION_VIEW,
  },
}
